import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Field, Page } from "@/components/Layout";

export function VerificaEmail({ base = "" }) {
  const [sp] = useSearchParams();
  const [stato, setStato] = useState("attesa");
  const [err, setErr] = useState("");
  const fatto = useRef(false);
  useEffect(() => {
    if (fatto.current) return;
    fatto.current = true;
    api.get("/auth/verifica-email", { params: { token: sp.get("token") } })
      .then(() => setStato("ok"))
      .catch((e) => { setErr(errMsg(e)); setStato("errore"); });
  }, [sp]);
  return (
    <Page className="max-w-md">
      <div className="card text-center py-12" data-testid="verify-email-status">
        {stato === "attesa" && <p>Verifica in corso…</p>}
        {stato === "ok" && (<><h1 className="font-display text-3xl">Email confermata</h1><Link to={`${base}/accedi`} className="btn-primary mt-6" data-testid="verify-login-btn">Accedi</Link></>)}
        {stato === "errore" && <p className="text-red-700">{err}</p>}
      </div>
    </Page>
  );
}

export function PasswordDimenticata() {
  const [email, setEmail] = useState("");
  const [ok, setOk] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    await api.post("/auth/password-dimenticata", { email }).catch(() => {});
    setOk(true);
  };
  return (
    <Page className="max-w-md">
      <h1 className="font-display text-4xl">Password dimenticata</h1>
      {ok ? <p className="card mt-6" data-testid="forgot-success">Se l'indirizzo è registrato riceverai un link per reimpostare la password.</p> : (
        <form onSubmit={submit} className="card mt-6 space-y-4">
          <Field label="Email"><input type="email" required className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></Field>
          <button className="btn-primary w-full" data-testid="forgot-submit-btn">Invia link</button>
        </form>
      )}
    </Page>
  );
}

export function ReimpostaPassword({ base = "" }) {
  const [sp] = useSearchParams();
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reimposta-password", { token: sp.get("token"), password });
      setMsg("Password aggiornata. Ora puoi accedere.");
    } catch (e2) {
      setMsg(errMsg(e2));
    }
  };
  return (
    <Page className="max-w-md">
      <h1 className="font-display text-4xl">Nuova password</h1>
      <form onSubmit={submit} className="card mt-6 space-y-4">
        <Field label="Nuova password (min. 8)"><input type="password" minLength={8} required className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" /></Field>
        {msg && <p className="text-sm" data-testid="reset-msg">{msg} <Link to={`${base}/accedi`} className="text-[#7E5BAF] underline">Accedi</Link></p>}
        <button className="btn-primary w-full" data-testid="reset-submit-btn">Salva</button>
      </form>
    </Page>
  );
}
